import ScanFromUUID from "./Scan.jsx";
import ScanOS from "./ScanOS.jsx";
import ScanInstallSteps from "./ScanInstallSteps.jsx";
import "../style/scan-card.css";

const ScanCard = () => {
  return (
    <div className="scan-card d-flex justify-content-center align-items-center">
      <div className="card shadow-sm border-1 rounded-4">
        <div className="d-flex flex-row align-items-center rounded-4">
          {/* 🔹 Left Panel: Scan from UUID */}
          <div className="scan-form-section p-3 w-50" style={{ fontSize: "14px" }}>
            <div className="d-flex flex-column justify-content-center align-items-center h-100">
              <ScanFromUUID />
            </div>
          </div>

          {/* 🔹 Divider */}
          <div 
            className="scan-divider" 
            style={{ width: "2px", height: "90%", backgroundColor: "#2a2a2a" }} 
          ></div>

          {/* 🔹 Right Panel: Scan OS */}
          <div className="overflow-y-auto h-100 w-50">
            <div className="scan-form-section p-3" style={{ fontSize: "14px" }}>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <ScanOS />
                <ScanInstallSteps />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ScanCard;
